import { debounce } from 'lodash';
import { useEffect, useMemo, useState } from 'react';

import { stringParser, useSearchParam } from '#hooks/shared/useSearchParam.ts';

export const SEARCH_DEBOUNCE_TIME = 300;

export const useDebouncedSearch = () => {
    const [search, setSearch, resetSearch] = useSearchParam('search', stringParser.default(''));
    const [searchInput, setSearchInput] = useState(search);

    useEffect(() => {
        setSearchInput(search);
    }, [search]);

    const debouncedSearch = useMemo(
        () =>
            debounce((input: string) => {
                input === '' ? resetSearch() : setSearch(input);
            }, SEARCH_DEBOUNCE_TIME),
        [resetSearch, setSearch]
    );

    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    const onSearch = (input: string) => {
        setSearchInput(input);
        debouncedSearch(input);
    };

    return { search, searchInput, onSearch };
};
